import { IssueTypeFieldsService as OvermapIssueTypeFieldsService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class IssueTypeFieldsService extends OvermapIssueTypeFieldsService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
